import React, { Dispatch, SetStateAction, useState } from 'react';
import { UploadedFile } from 'web-library/models/UploadedFile';
import { UploadDocumentType } from '../../../api/candidate/config/model';
import UploadDocumentTutorials from './UploadDocumentTutorials';
import { useGetResourceFileConfig } from '../../../api-refactored/onlineTutorials/useGetResourceFileConfig';

interface UploadDocumentTutorialsFormProps {
  files: UploadedFile[];
  setFiles: React.Dispatch<React.SetStateAction<UploadedFile[]>>;
  draftFiles?: UploadedFile[];
  setDraftFiles: React.Dispatch<React.SetStateAction<UploadedFile[]>>;
  setFileErrorMessage: Dispatch<SetStateAction<string>>;
  isLoading: boolean;
}

const UploadDocumentTutorialsForm = ({
  files,
  setFiles,
  draftFiles,
  setDraftFiles,
  isLoading,
  setFileErrorMessage,
}: UploadDocumentTutorialsFormProps) => {
  const [isSuccessFileConfig, setIsSuccessFileConfig] = useState<boolean>(false);
  const { data } = useGetResourceFileConfig({
    onSuccess: () => {
      setIsSuccessFileConfig(true);
    },
  });

  if (!isSuccessFileConfig) {
    return <></>;
  }

  return (
    <UploadDocumentTutorials
      files={files}
      setFiles={setFiles}
      draftFiles={draftFiles}
      setDraftFiles={setDraftFiles}
      uploadDocumentType={UploadDocumentType.SUPP_DOC}
      resourceFileConfig={data}
      isLoading={isLoading}
      setFileErrorMessage={setFileErrorMessage}
    />
  );
};
export default UploadDocumentTutorialsForm;
